function isNullish(value) {
  return value === null || value === undefined;
}

export { isNullish as i };
//# sourceMappingURL=nullish.js.map
